<template>
  <div class="tile is-ancestor">
    <div class="tile is-parent">
      <article
        v-if="userProfileClient.profile.id"
        class="tile is-child box"
      >
        <tabs type="boxed">
          <tab-pane label="Логин и пароль">
            <label class="label">Логин</label>
            <p class="control">
              <input
                v-model="userProfileClient.user.username"
                class="input"
                placeholder="Введите логин"
                autocomplete="off"
              >
            </p>
            <label class="label">Пароль</label>
            <p class="control">
              <input
                v-model="userProfileClient.user.password"
                class="input"
                type="password"
                placeholder="Введите пароль"
                autocomplete="off"
              >
            </p>
            <button
              class="button is-primary"
              v-on:click="saveLoginPassword()"
              :disabled="saving"
            >
              <span class="icon">
                <i class="fa fa-floppy-o"></i>
              </span>
              <span>Сохранить</span>
            </button>
          </tab-pane>
          <tab-pane label="Профиль пользователя">
            <label class="label">Отображаемое имя</label>
            <p class="control">
              <input
                v-model="userProfileClient.client.name"
                class="input displayName"
                type="text"
                autocomplete="off"
              >
            </p>

            <label class="label">Тип</label>
            <p class="control">
              <span class="select">
                <select v-model="userProfileClient.user.roleId">
                  <option
                    v-if="loggedRole <= 1"
                    value="1"
                  >СуперАдминистратор</option>
                  <option
                    v-if="loggedRole <= 2"
                    value="2"
                  >Администратор</option>
                  <option
                    v-if="loggedRole <= 4"
                    value="4"
                  >Партнер</option>
                  <option
                    v-if="loggedRole <= 8"
                    value="8"
                  >Реферер</option>
                  <option
                    v-if="loggedRole <= 16"
                    value="16"
                  >Клиент</option>
                  <option
                    v-if="loggedRole <= 32"
                    value="32"
                  >Клиент Автоматизации</option>
                </select>
              </span>
            </p>

            <label class="label">Центр затрат</label>
            <p class="control">
              <span class="select">
                <select v-model="userProfileClient.client.costCenterId">
                  <option
                    v-for="costCenter in costCenters"
                    v-bind:value="costCenter.id"
                  >
                    {{ costCenter.name }}
                  </option>
                </select>
              </span>
            </p>
            <button
              class="button is-primary"
              v-on:click="saveProfile"
              :disabled="saving"
            >
              <span class="icon">
                <i class="fa fa-floppy-o"></i>
              </span>
              <span>Сохранить</span>
            </button>
          </tab-pane>
          <tab-pane
            label="Client Config"
            v-if="userProfileClient && userProfileClient.client && userProfileClient.client.clientConfig"
          >
            <div class="table-responsive">
              <table class="table is-bordered is-striped is-narrow">
                <thead>
                <tr>
                  <th>Ключ</th>
                  <th>Значение</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(param, index) in Object.entries(userProfileClient.client.clientConfig)">
                  <td v-if="isSimpleParam(param) && param[0]!=='availableSmsGateways'">
                    <input
                      v-model="param[0]"
                      class="input"
                      type="text"
                      readonly
                    >
                  </td>
                  <td v-if="isSimpleParam(param) && param[0]!=='availableSmsGateways'">
                    <input
                      v-model="param[1]"
                      class="input"
                      placeholder="Параметр не указан"
                      type="text"
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      class="input"
                      type="text"
                      readonly
                      value="Доступные смс шлюзы"
                    >
                  </td>
                  <td>
                    <input
                      v-model="availableSmsGatewaysStr"
                      class="input"
                      placeholder="Параметр не указан"
                      type="text"
                    >
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive">
              <table class="table is-bordered is-striped is-narrow">
                <thead>
                <tr>
                  <th colspan="2">Перезвон по-умолчанию</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <input
                      value="Стратегия"
                      class="input"
                      type="text"
                      readonly
                    >
                  </td>
                  <td>
                    <input
                      v-model="userProfileClient.client.clientConfig.defaultPostponingConfig.strategy"
                      class="input"
                      placeholder="Параметр не указан"
                      type="text"
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      value="Количество попыток"
                      class="input"
                      type="text"
                      readonly
                    >
                  </td>
                  <td>
                    <input
                      v-model="userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.attempts"
                      class="input"
                      placeholder="Параметр не указан"
                      type="text"
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      value="Время ожидания"
                      class="input"
                      type="text"
                      readonly
                    >
                  </td>
                  <td>
                    <input
                      v-model="userProfileClient.client.clientConfig.defaultPostponingConfig.parameters.waitMinutes"
                      class="input"
                      placeholder="Параметр не указан"
                      type="text"
                    >
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive tariff billing">
              <table class="table is-bordered is-striped is-narrow">
                <thead>
                <tr>
                  <th colspan="2">Биллинг</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <input
                      value="Тариф"
                      class="input"
                      type="text"
                      readonly
                    >
                  </td>
                  <td>
                    <div class="control tariff">
                      <div class="select">
                        <select v-model="userProfileClient.client.tariff">
                          <option
                            v-for="tariff in tariffs"
                            v-bind:value="tariff.id"
                          >
                            {{ generateTariffLabel(tariff) }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      value="Биллинг"
                      class="input"
                      type="text"
                      readonly
                    >
                  </td>
                  <td>
                    <div class="control billing">
                      <div class="select">
                        <select v-model="userProfileClient.client.billingEnable">
                          <option value="">По умолчанию</option>
                          <option value="true">Включён</option>
                          <option value="false">Выключён</option>
                        </select>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <p class="control">
              <button
                class="button is-primary"
                v-on:click="saveClientConfig()"
                :disabled="saving"
              >
                <span class="icon">
                  <i class="fa fa-floppy-o"></i>
                </span>
                <span>Сохранить</span>
              </button>
            </p>
          </tab-pane>
          <tab-pane
            v-if="!!userProfileClient && userProfileClient.client && userProfileClient.client.id && canAccessAdditionalParameters(permissionKey)"
            label="Лицевой счёт"
          >
            <Balance
              :client-id="userProfileClient.client.id"
              :reload-client="load"
              :client-balance="userProfileClient.clientBalance"
            />
          </tab-pane>
        </tabs>
      </article>
      <article
        v-else-if="id==='new'"
        class="tile is-child box createNew"
      >
        <label class="label">Логин</label>
        <p class="control">
          <input
            v-model="userProfileClient.user.username"
            class="input"
            type="text"
            placeholder="Введите логин"
            autocomplete="off"
          >
        </p>
        <label class="label">Пароль</label>
        <p class="control">
          <input
            v-model="userProfileClient.user.password"
            class="input"
            type="password"
            placeholder="Введите пароль"
            autocomplete="off"
          >
        </p>

        <!--        <label class="label">Отображаемое имя</label>-->
        <!--        <p class="control">-->
        <!--          <input v-model="userProfileClient.client.name" class="input" type="text" autocomplete="off">-->
        <!--        </p>-->

        <label class="label">Тип</label>
        <p class="control">
          <span class="select">
            <select v-model="userProfileClient.user.roleId">
              <option
                v-if="loggedRole <= 1"
                value="1"
              >СуперАдминистратор</option>
              <option
                v-if="loggedRole <= 2"
                value="2"
              >Администратор</option>
              <option
                v-if="loggedRole <= 4"
                value="4"
              >Партнер</option>
              <option
                v-if="loggedRole <= 8"
                value="8"
              >Реферер</option>
              <option
                v-if="loggedRole <= 16"
                value="16"
              >Клиент</option>
              <option
                v-if="loggedRole <= 32"
                value="32"
              >Клиент Автоматизации</option>
            </select>
          </span>
        </p>

        <label class="label">Центр затрат</label>
        <p class="control">
          <span class="select">
            <select v-model="userProfileClient.client.costCenterId">
              <option
                v-for="costCenter in costCenters"
                v-bind:value="costCenter.id"
              >
                {{ costCenter.name }}
              </option>
            </select>
          </span>
        </p>

        <button
          class="button is-primary"
          v-on:click="saveNew"
          :disabled="saving"
        >
          <span class="icon">
            <i class="fa fa-floppy-o"></i>
          </span>
          <span>Создать</span>
        </button>

      </article>
      <article v-else>
        <loader-rollers1/>
      </article>
    </div>
  </div>
</template>

<script>
import VisCommon from '../components/VisCommon'
import Balance from '../clientes/Balance'
import {TabPane, Tabs} from 'vue-bulma-tabs'
import {mapGetters} from 'vuex'
import LoaderRollers1 from '../components/loaders/LoaderRollers1'

const USERS_API = '/api/userProfileClient'
const BILLING_API = '/billing/resources'

export default {
  name: 'UserNew',
  props: ['id'],
  extends: VisCommon,
  components: {
    LoaderRollers1,
    Balance,
    Tabs,
    TabPane
  },
  computed: {
    ...mapGetters([
      'authenticationToken',
      'loggedUser',
      'loggedRole',
      'loggedId'
    ])
  },
  data() {
    return {
      permissionKey: 'user',
      userProfileClient: {
        user: {
          roleId: 16
        },
        client: {
          clientConfig: {
            defaultPostponingConfig: {
              parameters: {}
            }
          },
          billingEnable: '',
          tariff: '',
          costCenterId: ''
        },
        profile: {}
      },
      clientConfigArray: [
        {
          key: '',
          value: ''
        }
      ],
      tariffs: [{name: '', id: ''}],
      costCenters: [],
      availableSmsGatewaysStr: '',
      saving: false
    }
  },
  created() {
    this.loadCostCenters()
    if (this.$props.id && this.$props.id !== 'new') {
      this.load()
      this.loadTariffs()
    }
  },
  methods: {
    load() {
      let that = this
      this.$http({
        url: USERS_API + '/getUserProfileClient/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        that.userProfileClient = response.data
        if (that.userProfileClient.user) {
          that.userProfileClient.user.password = ''
        }
        if (that.userProfileClient.client && that.userProfileClient.client.clientConfig && that.userProfileClient.client.clientConfig.availableSmsGateways) {
          that.availableSmsGatewaysStr = that.userProfileClient.client.clientConfig.availableSmsGateways.join()
        }
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка загрузки пользователя. ')
      })
    },
    isSimpleParam(param) {
      // return true
      return param.length === 2 && (typeof param[1] === 'string' || param[1] instanceof String || !param[1])
    },
    loadTariffs() {
      let that = this
      let url = BILLING_API + '/tariffs'
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.tariffs = that.tariffs.concat(response.data)
        })
        .catch((error) => {
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки списка тарифов. ')
        })
    },
    loadCostCenters() {
      let that = this
      let url = USERS_API + '/getCostCenters'
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.costCenters = that.costCenters.concat(response.data.response)
        })
        .catch((error) => {
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки списка центров затрат. ')
        })
    },
    generateTariffLabel(tariff) {
      let label
      if (tariff.name) {
        label = tariff.name + ' '
      }
      if (tariff.resources) {
        let resources = ''
        for (let key in tariff.resources) {
          if (tariff.resources[key].unitCost || tariff.resources[key].unitCost === 0) {
            if (resources) {
              resources += ';   '
            }
            resources = resources + key + ':' + tariff.resources[key].unitCost
          }
        }
        label = label + '  (' + resources + ')'
      }
      return label
    },
    saveLoginPassword() {
      this.save('/saveLoginPassword/' + this.userProfileClient.profile.id, {
        username: this.userProfileClient.user.username,
        password: this.userProfileClient.user.password
      })
    },
    saveProfile() {
      this.save('/saveProfile/' + this.userProfileClient.profile.id, {
        name: this.userProfileClient.client.name,
        roleId: this.userProfileClient.user.roleId,
        costCenterId: this.userProfileClient.client.costCenterId
      })
    },
    saveClientConfig() {
      let split = (this.availableSmsGatewaysStr || '').split(',')
      for (let i = 0; i < split.length; i++) {
        split[i] = split[i].trim()
      }
      this.userProfileClient.client.clientConfig.availableSmsGateways = split
      this.save('/saveClientConfig/' + this.userProfileClient.profile.id, {
        billingEnable: this.userProfileClient.client.billingEnable || '',
        tariff: this.userProfileClient.client.tariff || ''
      }, this.userProfileClient.client.clientConfig)
    },
    saveNew() {
      this.save('/saveNew/', {
        name: this.userProfileClient.client.name,
        roleId: this.userProfileClient.user.roleId,
        username: this.userProfileClient.user.username,
        password: this.userProfileClient.user.password,
        costCenterId: this.userProfileClient.client.costCenterId
      }, null, true)
    },
    save(suburl, params, data, reload, cb) {
      let that = this
      this.saving = true
      let paramsUrl = '?a=1'
      if (params) {
        for (let key in params) {
          paramsUrl += '&' + key + '=' + params[key]
        }
      }
      this.$http.post(USERS_API + suburl + paramsUrl, data, {headers: this.prepareSecurityHeader()}
      ).then((response) => {
        this.saving = false
        that.openNotificationWithType('info', 'Данные сохранены.')
        if (!that.$props.id || that.$props.id === 'new') {
          that.$props.id = response.data
          // document.location.replace(document.location.replace('new', that.$props.id))
        }
        if (reload) {
          that.load()
        }
      }).catch((error) => {
        this.saving = false
        console.log(error)
        that.openNotificationWithType('danger', error.response.data)
      })
    }
  }
}
</script>

<style scoped>
article.createNew {
  max-width: 360px;
}

article.createNew button {
  float: right;
}

.displayName {
  max-width: 350px;
}
</style>



// WEBPACK FOOTER //
// User.vue?42d41dfe